import { yup } from '@guiker/yup-util'

export const searchListingQuerySchema = yup.object({
  page: yup.number().min(1).default(1),
  perPage: yup.number().min(1).max(100).default(9),
})

export type SearchListingQuerySchema = yup.InferType<typeof searchListingQuerySchema>
